import { ReactNode } from "react";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./msalConfig";

/**
 * Wraps the app in MSAL's React context so any component can call
 * useMsal() / useAccount() / useIsAuthenticated().
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
}
